import { useMemo } from "react";

import { TextInput } from "@portex-pro/ui-components";

const MemoizedTextInput = (props: React.ComponentProps<typeof TextInput>): React.ReactElement => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const MemoizedComponent = useMemo(() => <TextInput {...props} />, [props.value]);

  return MemoizedComponent;
};

export default MemoizedTextInput;
